import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { navigate } from '@reach/router';
import '../css/buttonGame.scss';


const ButtonGame = () => {
  const user = useSelector(({ login }) => login.user);

  const logout = () => {
    localStorage.removeItem('persist:kino');
    localStorage.clear();
    window.location.reload();
  };
  return (
    <>
      {user ? (
        <button className="play-button-logout" onClick={logout}>Salir</button>  
      ) : (
        <>
          <a className="play-button" href="https://compras.sellatuserial.com/landing">Juega YA</a>
          <button 
            className="play-button" 
            data-bs-toggle="modal" 
            data-bs-target="#infoModal"
          >
            ¿En qué consiste?
          </button>
        </>
      )}

      <div 
        className="modal fade" 
        id="infoModal" 
        tabIndex="-1" 
        aria-labelledby="infoModalLabel" 
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-center w-100" id="infoModalLabel">
                En qué consiste:
              </h5>
              <button 
                type="button" 
                className="btn-close" 
                data-bs-dismiss="modal" 
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body text-justify">
              Prepárate para jugar y ganar con todos los juegos de la LVBP y en otros deportes.
              <br />
              <br />
              Compra tu(s) serial(es) para cada juego ofrecido y gánate el pote acumulado.
              <br />
              <br />
              Cada partido tiene su pote recolectado a premiar el cual va creciendo minuto a minuto hasta el momento del sorteo que se lanzará antes de finalizar el mismo.
              <br />
              <br />
              Se premiará 1 solo serial por juego y tú puedes ser el afortunado.
              <br />
              <br />
              ¡Asegura tu oportunidad y únete a la emoción de ganar en tus deportes favoritos!
            </div>
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-secondary" 
                data-bs-dismiss="modal"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ButtonGame